// 工作台跳转就页面信息
export default {
  namespaced: true,
  state: {
    saveInfo: null
  },
  mutations: {
    SET_SAVE_INFO: (state, data) => {
      state.saveInfo = data.isCheck
    }
  }
}